module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Lamp#2-7a9aa14e544a840ddf975de9bdc3f14d.svg";